import { Flex } from '@chakra-ui/react'
import React, { useEffect, useState } from 'react'
import IconDislike from '~/assets/svgs/icon-dislike.svg?react'
import IconLike from '~/assets/svgs/icon-like.svg?react'
import { Close } from '~/components/compositional/QuickActions'
import { MangoButtonVariant } from '~/components/shared/componentStyles/MangoButton.style'
import { MangoButton } from '~/components/shared/MangoButton'
import useCloudwatchLogger from '~/hooks/useCloudwatchLogger'
import { Size } from '~/types/ThemeTypes'

import { useFeedbackToastStyle } from './componentStyles/FeedbackToast.style'

interface FeedbackToastProps {
  onClose: () => void
  onOpenFeedbackModal: () => void
}

export const FeedbackToast = (props: FeedbackToastProps) => {
  const styles = useFeedbackToastStyle()
  const [ratedPositive, setRatedPositive] = useState(false)
  const { logger } = useCloudwatchLogger('FeedbackToast')

  useEffect(() => {
    if (ratedPositive) {
      setTimeout(() => {
        props.onClose()
      }, 2000)
    }
  }, [ratedPositive])

  const handleLike = () => {
    logger?.info('call_fb_thumbs_up')
    setRatedPositive(true)
  }

  const handleDislike = () => {
    logger?.info('call_fb_thumbs_down')
    props.onOpenFeedbackModal()
    props.onClose()
  }

  const handleClose = () => {
    logger?.info('call_fb_dismiss')
    props.onClose()
  }

  return (
    <Flex sx={styles.container}>
      <Flex justifyContent="space-between">
        <Flex sx={styles.header}>Rate your call audio</Flex>
        <Close
          size={Size.sm}
          iconProps={{ boxSize: '0.625rem' }}
          onClick={handleClose}
          tooltipText=""
        />
      </Flex>
      {ratedPositive ? (
        <Flex sx={styles.message}>Thanks!</Flex>
      ) : (
        <Flex gap="5" justifyContent="center">
          <MangoButton
            variant={MangoButtonVariant.Default_200}
            width={4}
            onClick={handleLike}
          >
            <IconLike />
          </MangoButton>
          <MangoButton
            variant={MangoButtonVariant.Default_200}
            width={4}
            onClick={handleDislike}
          >
            <IconDislike />
          </MangoButton>
        </Flex>
      )}
    </Flex>
  )
}
